import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { formatDatesToString, isDateBetween } from '@core/services/helper.service';
import { ToastService } from '@core/services/toast.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-assessment-date-modal',
    templateUrl: './assessment-date-modal.component.html',
    styleUrls: ['./assessment-date-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssessmentDateModalComponent implements OnInit {
  constructor(
    private toast: ToastService,
    public dialogRef: MatDialogRef<AssessmentDateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private translocoService: TranslocoService
  ) {}

  selectedDate: any = null;
  startDate: Date = new Date(this.dialogData.minDate);
  endDate: Date = new Date(this.dialogData.maxDate);
  customMessage: string = this.dialogData.customMessage ?? null;
  title: string = this.dialogData.title ?? null
  today: Date = new Date();

  ngOnInit(): void {
    this.selectedDate = this.dialogData.assessmentDate
      ? new Date(this.dialogData.assessmentDate)
      : new Date();
  }

  onSubmit() {
    if (!this.selectedDate) {
      this.toast.error(this.translocoService.translate('user.inputRating.assessmentDateModal.dateRequiredToast'));
      return;
    }

    const checkDate = new Date(this.selectedDate);

    if (!isDateBetween(this.startDate, this.endDate, checkDate)) {
      this.toast.error(
        this.translocoService.translate('user.inputRating.assessmentDateModal.dateOutOfTermToast')
      );
      return;
    }

    if (checkDate < new Date(this.dialogData?.enrollmentDate)) {
      this.toast.error(
        this.translocoService.translate('user.inputRating.assessmentDateModal.datePriorToEnrollmentToast')
      );
      return;
    }

    this.dialogRef.close({
      assessmentDate: formatDatesToString(this.selectedDate),
    });
  }
}
